import React, { Component } from 'react'
import ButtonPrevious from '../UI/ButtonPrevious'

class SubscribeStepConfirm extends Component {
	render() {
		const themeColor = '#' + this.props.theme.color1
		const client = this.props.client

		const rows = [
			{ label: 'Civilité', value: client.civility || '—' },
			{ label: 'Prénom', value: client.firstname || '—' },
			{ label: 'Nom', value: client.lastname || '—' },
			{ label: 'Date de naissance', value: client.birthday || '—' },
			{ label: 'Email', value: client.email_masked || '—' },
		]

		return (
			<div>
				<ButtonPrevious
					theme={this.props.theme}
					handlePreviousBtn={this.props.handlePreviousBtn}
				/>
				<div style={{ backgroundColor: themeColor }} className="h-52 z-0 px-8 text-center">
					<p className="text-2xl text-white pt-14 mt-0">Vérification</p>
					<h1 className="text-3xl text-white font-semibold m-0 pt-2">Est-ce bien vous ?</h1>
				</div>
				<div className="rounded-t-3xl z-10" style={{ backgroundColor: "#ffffff", marginTop: "-2rem" }}>
					<div className="px-10 pt-12 pb-10">
						<p className="text-gray-500 text-base mb-6">
							Voici les informations liées à votre réservation. Confirmez-vous être cette personne ?
						</p>
						<div className="rounded-2xl border border-gray-100 overflow-hidden mb-8" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.07)' }}>
							{rows.map(({ label, value }, i) => (
								<div
									key={i}
									className="flex justify-between items-center px-5 py-4"
									style={{ borderBottom: i < rows.length - 1 ? '1px solid #f3f4f6' : 'none' }}
								>
									<span className="text-sm text-gray-400 font-medium">{label}</span>
									<span className="text-sm text-gray-800 font-semibold">{value}</span>
								</div>
							))}
						</div>
						<button
							className="items-center px-6 py-5 border border-transparent text-xl font-medium rounded-full w-full shadow-sm text-white mb-4"
							style={{ backgroundColor: themeColor }}
							onClick={this.props.onConfirmSelf}
						>
							C'est moi
						</button>
						<button
							className="items-center px-6 py-4 text-base font-semibold rounded-full w-full border-2"
							style={{ color: themeColor, borderColor: themeColor, backgroundColor: 'white' }}
							onClick={this.props.onConfirmParticipant}
						>
							Je suis un participant au séjour
						</button>
					</div>
				</div>
			</div>
		)
	}
}

export default SubscribeStepConfirm
